// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1TaY5","gfeWrapper":"CalendarEvent_gfeWrapper__aj2Ok"};